import { render, staticRenderFns } from "./BasicLayout.vue?vue&type=template&id=e2d82e8c&scoped=true"
import script from "./BasicLayout.vue?vue&type=script&lang=js"
export * from "./BasicLayout.vue?vue&type=script&lang=js"
import style0 from "./BasicLayout.vue?vue&type=style&index=0&id=e2d82e8c&prod&lang=less&scoped=true"
import style1 from "./BasicLayout.vue?vue&type=style&index=1&id=e2d82e8c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d82e8c",
  null
  
)

export default component.exports